import React, { useState, useEffect } from 'react';
import {
  GridView,
  SimpleView,
} from '@digital/ui';

import CRFTipoProjeto from './TipoProjeto';
import CRFAcronimoProjetosTable from './AcronimoProjetoTable';

import {
  CrfTipoProjeto,
  getAllCfTipoProjetoGrupos,
  createCfTipoProjetoGrupo,
  deleteCfTipoProjetoGrupo,
  updateCfTipoProjetoGrupo,
} from '@app/api/crf/acronimo/projeto/crfTipoProjetoGrupo';

import {
  createCrfTipoProjetoCategoria,
  deleteCrfTipoProjetoCategoria,
  updateCrfTipoProjetoCategoria,
  getAllCrfTipoProjetoCategorias,
} from '@app/api/crf/acronimo/projeto/crfTipoProjetoCategoria';

import {
  createCrfAcronimoProjeto,
  CrfAcronimoProjeto,
  deleteCrfAcronimoProjeto,
  getAllCrfAcronimosProjeto,
  updateCrfAcronimoProjeto,
} from '@app/api/crf/acronimo/projeto/crfAcronimosProjeto';


const CRFAcronimoProjeto = () => {
  const [acronimos, setAcronimos] = useState<CrfAcronimoProjeto[]>([]);
  const [categorias, setCategorias] = useState<CrfTipoProjeto[]>([]);
  const [grupos, setGrupos] = useState<CrfTipoProjeto[]>([]);

  const [shouldUpdate, setShouldUpdate] = useState<boolean>(false);

  const fetchData = () => {

    const getGrupos = async () => {
      const result = await getAllCfTipoProjetoGrupos();
      if (result) setGrupos(result);
    };

    const getCategorias = async () => {
      const result = await getAllCrfTipoProjetoCategorias();
      if (result) setCategorias(result);
    };

    const getAcronimoProjetos = async () => {
      const result = await getAllCrfAcronimosProjeto();
      if (result) setAcronimos(result);
    };

    getGrupos();
    getCategorias();
    getAcronimoProjetos();
  };

  useEffect(() => fetchData(), []);
  useEffect(() => fetchData(), [shouldUpdate]);

  return (
    <SimpleView>
      <GridView noform>
        {true && (
          <>
            <CRFAcronimoProjetosTable
              acronimosProjeto={acronimos || []}
              categorias={(categorias.length > 0 && categorias
                .map((a: any) => ({ text: a.data.nome, value: a.id.toString() }))) || []
              }
              grupos={(grupos.length > 0 && grupos
                .map((a: any) => ({ text: a.data.nome, value: a.id.toString() }))) || []
              }
              handleCreate={createCrfAcronimoProjeto}
              handleUpdate={updateCrfAcronimoProjeto}
              handleDelete={deleteCrfAcronimoProjeto}
              shouldUpdate={setShouldUpdate}
              isUpdate={shouldUpdate}
            />

            <CRFTipoProjeto
              titulo="Categoria"
              label="Nome da Categoria"
              data={(categorias.length > 0 && [].slice.call(categorias).sort((a: any, b: any) => a.data.codigo - b.data.codigo)) || []}
              handleCreate={createCrfTipoProjetoCategoria}
              handleUpdate={updateCrfTipoProjetoCategoria}
              handleDelete={deleteCrfTipoProjetoCategoria}
              shouldUpdate={setShouldUpdate}
              isUpdate={shouldUpdate}
            />

            <CRFTipoProjeto
              titulo="Grupo"
              label="Nome do Grupo"
              data={(grupos.length > 0 && [].slice.call(grupos).sort((a: any, b: any) => a.data.codigo - b.data.codigo)) || []}
              handleCreate={createCfTipoProjetoGrupo}
              handleUpdate={updateCfTipoProjetoGrupo}
              handleDelete={deleteCfTipoProjetoGrupo}
              shouldUpdate={setShouldUpdate}
              isUpdate={shouldUpdate}
            />

          </>
        )}
      </GridView>
    </SimpleView>
  );
};

export default CRFAcronimoProjeto;
